import React from 'react';
import NavigationBar from './components/NavigationBar';
import {connect} from 'react-redux';
import {RootState} from '../../reducer';
import {ToastContainer} from 'react-toastify';
import {DispatchProps, Props, StateProps} from './Props';
import {Dispatch} from 'redux';
import {changeCurrentRoute, LayoutActionTypes, layoutComponentRequestedLogoutCurrentUser} from './actions';
import ThemeContext from '../../contexts/ThemeContext';
import {ThemeColorScheme} from '../../themes';
import {Outlet} from 'react-router-dom';

const Layout: React.FunctionComponent<Props> = ({
    currentThemeColorBlind,
    currentThemeColorScheme,
    notification,
    userProfile,
    onChangeCurrentRoute,
    onRequestedLogout,
}) => {
    const themeContext = React.useMemo(() => {
        return {
            currentColorSchemeIsDark: currentThemeColorScheme === ThemeColorScheme.DARK,
            currentColorSchemeIsSuitableForColorBlindness: currentThemeColorBlind,
            themeColorScheme: currentThemeColorScheme,
        };
    }, [currentThemeColorBlind, currentThemeColorScheme]);

    return (
        <ThemeContext.Provider value={themeContext}>
            <NavigationBar
                notification={notification}
                userProfile={userProfile}
                changeCurrentRoute={onChangeCurrentRoute}
                onRequestedLogout={onRequestedLogout}
            />

            <Outlet />

            <ToastContainer closeOnClick={false} draggable={false} />
        </ThemeContext.Provider>
    );
};

const mapStateToProps = (state: RootState): StateProps => ({
    currentThemeColorBlind: state.userSettings.theme.colorBlind,
    currentThemeColorScheme: state.userSettings.theme.colorScheme,
    notification: state.notification.currentNotification,
    userProfile: state.keycloakAuthentication.userProfile,
});

const mapDispatchToProps = (dispatch: Dispatch<LayoutActionTypes>): DispatchProps => ({
    onChangeCurrentRoute: (route: string) => dispatch(changeCurrentRoute(route)),
    onRequestedLogout: () => dispatch(layoutComponentRequestedLogoutCurrentUser()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
